const ITEMS = ["NOM-001-STPS Edificios", "NOM-002-STPS Incendios", "NOM-017-STPS EPP", "NOM-019-STPS Comisiones", "NOM-030-STPS Servicios preventivos", "NOM-026-STPS Señalización", "ISO 9001:2015 Calidad"];

export const Marquee = () => (
  <section className="relative border-y border-white/10 bg-[#F59E0B] text-[#0B0F17] overflow-hidden -rotate-1 my-6" data-testid="norms-marquee">
    <div className="flex w-max animate-marquee py-5">
      {[0, 1].map((k) => (
        <div key={k} className="flex shrink-0" aria-hidden={k === 1}>
          {ITEMS.map((t) => (
            <span key={t + k} className="font-display-x flex items-center gap-8 pr-8 text-2xl sm:text-4xl font-extrabold uppercase italic tracking-tight whitespace-nowrap">
              {t}
              <svg viewBox="0 0 24 24" className="w-6 h-6 sm:w-8 sm:h-8"><path d="M12 2 22 20H2Z" fill="#0B0F17" /></svg>
            </span>
          ))}
        </div>
      ))}
    </div>
  </section>
);
